export default __webpack_public_path__ + "static/media/bg-masthead-2-320w.d13b1449.jpg";